import { type OportunidadesDataInterface } from "interfaces/oportunidades.interface";
import React from "react";

import { RiArrowRightSLine } from "react-icons/ri";
import { useParams } from "react-router-dom";
import * as Styles from "./styles";
import StepByStep from "../StepByStep/stepbystep.component";

interface Props {
  data: OportunidadesDataInterface;
}

function OportunidadesItemGerente({ data }: Props) {
  const params: any = useParams();
  const colorButtonText = () => {
    switch (data.status) {
      case "Cancelada":
        return "#F43636";
        break;
      case "Vendida":
        return "#4CAF50";
        break;
      default:
        return "#2196F3";
        break;
    }
  };
  return (
    <Styles.Container>
      <Styles.ItemTable>
        <Styles.FlexContainer className="col col-1" data-label="Produto">
          {data?.urlImagemEmpreendimento ? (
            <Styles.PhotoImg src={data?.urlImagemEmpreendimento} />
          ) : null}
          <div style={{ marginLeft: 16 }}>
            <Styles.TitleText>
              {data?.nomeEmpreendimento ?? "--"}
            </Styles.TitleText>
            <Styles.FlexContainerText style={{ marginTop: 8 }}>
              <Styles.SubTitleText>
                Bloco: {data?.bloco ?? "--"}
              </Styles.SubTitleText>
              <Styles.SubTitleText>
                Unidade: {data?.unidade ?? "--"}
              </Styles.SubTitleText>
            </Styles.FlexContainerText>
          </div>
        </Styles.FlexContainer>
        <Styles.FlexContainer className="col col-2" data-label="ID Proposta">
          <Styles.TextCotacao className="idProposta">
            {data.numeroCotacao}
          </Styles.TextCotacao>
        </Styles.FlexContainer>
        <Styles.FlexContainer className="col col-3">
          <Styles.TextFicha>{data.numeroFicha ?? "---"}</Styles.TextFicha>
        </Styles.FlexContainer>
        <Styles.FlexContainer className="col col-4" data-label="Status">
          <Styles.TextEtapa>{data.nomeEtapa}</Styles.TextEtapa>
        </Styles.FlexContainer>
        <Styles.FlexContainer className="col col-5">
          <Styles.ArrowButton
            href={`/lead-detail/${params?.idLeadCorretor}/proposition-detail/${data.numeroCotacao}`}
          >
            <RiArrowRightSLine size={24} />
          </Styles.ArrowButton>
        </Styles.FlexContainer>
      </Styles.ItemTable>
      {/* <StepByStep steps={data?.listaEtapas?.etapas} /> */}
    </Styles.Container>
  );
}

export default OportunidadesItemGerente;
